module.exports = __webpack_public_path__ + "img/login_header.73c19858.jpg";